import * as React from "react";

interface UserDistrictInfo {
    district: {
        id: string;
        region: string;
    };
    id: string;
    isKAD: boolean;
}

interface UnderAgeGate {
    approvalGivenAt: string;
    daysUntilCutoff: number;
    parentEmail: string;
}

interface SchoolAffiliation {
    id: string;
    location: string;
}

export interface UserAttributes {
    // sync-start:user-profile-type 1281602579 https://github.com/Khan/webapp/blob/master/services/fastly-khanacademy-compute/cross_service/get_user_profile.go
    // From User
    kaid: string;
    nickname: string;
    region: string | null;
    schoolAffiliation: SchoolAffiliation | null;
    userDistrictInfos: ReadonlyArray<UserDistrictInfo> | null;
    isParent: boolean;
    isTeacher: boolean;
    hideVisual: boolean;
    hasChildren: boolean;
    hasCoachees: boolean;
    includesDistrictOwnedData: boolean;
    underAgeGate: UnderAgeGate | null;
    hasCoach: boolean;
    hasClasses: boolean;
    isDeveloper: boolean;
    isPublisher: boolean;
    canParticipateInABTesting: boolean;
    prefersReducedMotion: boolean;
    hasAccessToAIGuideParent: boolean;
    hasAccessToAIGuideTeacher: boolean;
    hasAccessToAIGuideLearner: boolean;
    hasAccessToAIGuideDistrictAdmin: boolean;
    hasAccessToAIGuideCompanionMode: boolean;
    isInKhanClassroomDistrict?: boolean;

    // Top-level
    actorIsImpersonatingUser: boolean;
    isAIGuideEnabled: boolean;
    hasAccessToAIGuideDev: boolean;
    // sync-end:user-profile-type
}

/**
 * This is what is embedded in the page. In rare circumstances we can use
 * this to get the user attributes of the current user OUTSIDE of the
 * React render tree, such as in the SiteInit logic.
 */
export function __InternalGetUserAttributes() {
    return (globalThis.__USER_PROFILE__ as UserAttributes | undefined) ?? null;
}

/**
 * Used for getting the attributes of the current user.
 *
 * Returns null if the user is not logged in.
 */
export function useUserAttributes() {
    return React.useContext(UserAttributesContext);
}

/**
 * Used for mocking user attributes in tests.
 *
 * This is used by our test harness logic to provide a user attributes
 * object to the component tree.
 */
export const UserAttributesContext = React.createContext<UserAttributes | null>(
    __InternalGetUserAttributes(),
);
